import React, { useState } from 'react';
import { observabilityService } from '../../services/api';
import { formatDistanceToNow, format } from 'date-fns';
import { CheckCircle, Clock } from 'lucide-react';
import './IncidentList.css';

const SEV_CLS = { critical:'sev-critical', high:'sev-high', medium:'sev-medium', low:'sev-low' };
const TYPE_LABELS = {
  offline: 'Offline', cpu_critical: 'CPU Critical', mem_critical: 'Mem Critical',
  disk_critical: 'Disk Critical', check_failed: 'Check Failed', degraded: 'Degraded', manual: 'Manual',
};

export default function IncidentList({ incidents, onRefresh }) {
  const [actioning, setActioning] = useState(null);

  const handleAction = async (id, status, note) => {
    setActioning(id);
    try {
      await observabilityService.updateIncident(id, { status, note });
      onRefresh();
    } finally { setActioning(null); }
  };

  if (!incidents.length) return (
    <div className="incident-empty card">
      <CheckCircle size={32} color="var(--success)" />
      <p>No open incidents — all systems nominal</p>
    </div>
  );

  return (
    <div className="incident-list">
      {incidents.map(inc => (
        <div key={inc._id} className={`incident-item card ${SEV_CLS[inc.severity]}`}>
          <div className="incident-item__header">
            <span className={`badge sev-badge sev-badge--${inc.severity}`}>{inc.severity}</span>
            <span className="incident-type">{TYPE_LABELS[inc.type] || inc.type}</span>
            <span className="incident-status">{inc.status}</span>
            <span className="incident-time">
              <Clock size={11} />
              {formatDistanceToNow(new Date(inc.createdAt), { addSuffix: true })}
            </span>
          </div>

          <div className="incident-title">{inc.title}</div>

          <div className="incident-meta">
            <span>{inc.deployment?.name}</span>
            <span>·</span>
            <span>{inc.client?.name}</span>
            {inc.acknowledgedBy && <><span>·</span><span>Ack'd by {inc.acknowledgedBy?.name}</span></>}
          </div>

          <div className="incident-actions">
            {inc.status === 'open' && (
              <button className="btn btn-ghost" disabled={actioning === inc._id}
                onClick={() => handleAction(inc._id, 'acknowledged')}>
                Acknowledge
              </button>
            )}
            {['open','acknowledged'].includes(inc.status) && (
              <button className="btn btn-primary" disabled={actioning === inc._id}
                onClick={() => handleAction(inc._id, 'resolved')}>
                <CheckCircle size={13} /> Mark Resolved
              </button>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
